import { Vector3 } from "three";
import { CharacterAnimationController, CharacterAnimationState } from "../animations/CharacterAnimationController";
import { Character } from "../Character";
import { ICharacterState } from "./ICharacterState";
import { CharacterStates } from "./CharacterStates";
import { AudioController, Sfx } from "../../../AudioController";

export class ThrowState implements ICharacterState {
    private nextState: CharacterStates;
    private throwCalled: boolean;
    private recharged: boolean;

    public constructor(
        private readonly character: Character,
        private readonly animationController: CharacterAnimationController,
        private readonly audioController: AudioController
    ) {
        this.throwCalled = false;
        this.recharged = false;
        this.nextState = CharacterStates.THROW;
    }

    public enter(): void {
        this.animationController.onAnimationProgress.add(this.handleAnimationProgress, this);
        this.animationController.onClipEnd.add(this.handleClipEnd, this);

        const animationState = this.animationController.getWeaponThrowState(this.character.currentWeapon.value);
        this.animationController.transitToState(animationState);
    }

    public exit(): void {
        this.animationController.onAnimationProgress.remove(this.handleAnimationProgress, this);
        this.animationController.onClipEnd.remove(this.handleClipEnd, this);
        if (this.recharged) {
            this.recharged = false;
        } else {
            this.character.equipProjectile();
        }
        this.throwCalled = false;
        this.nextState = CharacterStates.THROW;
    }

    public process(_dt: number): CharacterStates {
        return this.nextState;
    }

    public onInput(_value: Vector3): void { }

    public onTakeDamage(amount: number): void {
        this.audioController.playSfx(Sfx.Hit);
        this.character.health.setValue(Math.max(this.character.health.value - amount, 0));
        if ((this.character.isHitReadyDamage && this.character.isHitReadyTime) || !this.character.alive) {
            this.character.throwTargetPosition = null;
            this.nextState = CharacterStates.HIT;
        }
    }

    private handleAnimationProgress(state: CharacterAnimationState, progress: number): void {
        switch (state) {
            case CharacterAnimationState.Throw:
            case CharacterAnimationState.ThrowBoomerang: {
                if (progress > 0.4 && !this.throwCalled) {
                    this.throwCalled = true;
                    this.character.tryThrowProjectile();
                }
                break;
            }
        }
        if (progress > 0.6 && !this.recharged) {
            this.recharged = true;
            this.character.equipProjectile();
        }
    }

    private handleClipEnd(_state: CharacterAnimationState): void {
        this.nextState = CharacterStates.IDLE;
    }
}
